import { api } from "api/apiService";

/**
 * Завантажує повний список категорій Prom.
 * @returns {Promise<Array>} Проміс, що повертає масив з об'єктами категорій Prom.
 */
export const fetchCategoriesProm = () => {
  return api.get("/prom-categories");
};
